import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class BlocksService {
  constructor(private restService: RestService) {}

  blocksHotelSummary(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('blockshotel/summary', val_params);
  }

  // blockshotel ====================
  blocksHotelList(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('blockshotel/list', val_params);
  }

  blocksHotelDetail(val_id: number) {
    return this.restService.get('blockshotel/detail', val_id);
  }

  blocksHotelSave(data: any) {
    return this.restService.save('blockshotel/save', data);
  }

  blocksHotelDelete(val_id: number, data: any) {
    return this.restService.update('blockshotel/update_delete', val_id, data);
  }

  blocksHotelisDebt(val_id: number, data: any) {
    return this.restService.update('blockshotel/isdebt', val_id, data);
  }

  // blocksagency ====================
  blocksAgencySummary(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('blocksagency/summary', val_params);
  }

  blocksAgencyList(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('blocksagency/list', val_params);
  }

  blocksAgencyDetail(val_id: number) {
    return this.restService.get('blocksagency/detail', val_id);
  }

  blocksAgencySave(data: any) {
    return this.restService.save('blocksagency/save', data);
  }

  blocksAgencyDelete(val_id: number, data: any) {
    return this.restService.update('blocksagency/update_delete', val_id, data);
  }

  blocksAgencyisDebt(val_id: number, data: any) {
    return this.restService.update('blocksagency/isdebt', val_id, data);
  }
  
}
